export const breadcrumbsReplaceDefault = {
  '[poolId]': null,
  '[tableId]': null,
  '[transformId]': null,
  '[sourceId]': null,
  '[bucketId]': null,
  '[credentialId]': null,
};
